import React from 'react';
import Lottie from 'react-lottie';
import bangMark from '@graphic/bangMark.json';

import classnames from 'classnames/bind';
import styles from './phsBanner.module.scss';
const cx = classnames.bind(styles);

const options = {
  loop: true,
  autoplay: true,
  animationData: bangMark,
};

const PhsBanner = () => {
  return (
    <div className={cx('phsBannerArea')}>
      {/* description 영역 */}
      <div className={cx('descArea')}>
        <div className={cx('visualWrap')}>
          <Lottie options={options} />
        </div>

        <p className={cx('desc')}>
          <span className={cx('emphasis')}>개발자 검사</span>는 구직자가 보유한 개발자 역량을 정확하게 진단하고,
          <br />
          올바른 취업으로 안내합니다.
        </p>
      </div>

      {/* stepList 영역 */}
      <ul className={cx('stepList')}>
        <li className={cx('listItem', 'step1')}>심층 결과표와 취업 가이드 확인</li>
        <li className={cx('listItem', 'step2')}>개발자의 핵심 역량과 개발 능력을 진단</li>
        <li className={cx('listItem', 'step3')}>검사 결과 기반의 최적의 맞춤 기업 추천</li>
      </ul>
    </div>
  );
};

export default PhsBanner;
